import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { Tutorial, DataList } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class TutorialService {
  constructor(private apiService: ApiService) {}

  list(): Observable<DataList<Tutorial>> {
    return this.apiService.get<DataList<Tutorial>>('user/tutorials?length=25').pipe();
  }

  show(id: number): Observable<Tutorial> {
    return this.apiService.get<Tutorial>('user/tutorials/' + id).pipe();
  }
}
